import { IResponsiveConfig } from '@viablelogic/ngx-responsive';

/**
 * Konfiguracja dla biblioteki ngx-responsive.
 *
 * UWAGA!!
 * W przypadku zmiany poniższych wartości, naelży nadpisać breakpointy biblioteki Bootstrap (w variables.scss).
 */
export const AppResponsiveConfig: IResponsiveConfig = {
  breakPoints: {
    xs: {max: 575},
    sm: {min: 576, max: 767},
    md: {min: 768, max: 991},
    lg: {min: 992, max: 1199},
    xl: {min: 1200, max: 1799},
    xxl: {min: 1800}
  },
  debounceTime: 100
};
